import { useRouter, type AnyRouter } from "@tanstack/react-router";
import type { ComponentType } from "react";

// 경계만 풀면 loader·beforeLoad 오류(match.status error)가 그대로 다시 던져진다 — invalidate 로 다시 읽힌 뒤 경계를 푼다.
export const retryRoute = async (router: Pick<AnyRouter, "invalidate">, reset?: () => void): Promise<void> => {
  try {
    await router.invalidate();
  } finally {
    reset?.();
  }
};

export const useRouteRetry = (reset?: () => void): (() => void) => {
  const router = useRouter();
  return () => {
    retryRoute(router, reset).catch((error: unknown) => console.error("[route-retry]", error));
  };
};

// 라우트 errorComponent 를 감싸 「다시 시도」 가 reset 대신 retryRoute 를 부르게 한다 — routeRetries 표시는 라우트 표 검사용.
export const withRouteRetry = <P extends { reset: () => void }>(Failure: ComponentType<P>) => {
  const RetryingError = (props: P) => {
    const retry = useRouteRetry(props.reset);
    return <Failure {...props} reset={retry} />;
  };
  return Object.assign(RetryingError, { routeRetries: true as const });
};
